import React from "react";
import ReactDOM from "react-dom/client";
import { Button, Column, Grid, Tile } from "@carbon/react";
import { ArrowRight } from "@carbon/react/icons";
import { DomainCarbonExperience } from "./carbon-experience";
import "./carbon-alignment.scss";
import "./carbon-product-alignment.scss";
import "./carbon-dns-alignment.scss";
import "./carbon-native-alignment.scss";
import "./portal-moved.scss";
import "./carbon-theme-contrast-fixes.scss";

function dashDestination() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const source = new URLSearchParams(window.location.search);
  if (path === "/dash/notifications") return "https://dash.kmerhosting.com/notifications/";
  if (path === "/invoices" || path === "/profile") return "https://dash.kmerhosting.com/";

  const target = new URL("https://dash.kmerhosting.com/domains/");

  const domain = String(source.get("domain") || "").trim().toLowerCase();
  if (domain) target.searchParams.set("domain", domain);

  if (path === "/transfer-domain") target.searchParams.set("mode", "transfer");
  else if (path === "/register-domain") target.searchParams.set("mode", "registration");

  return target.toString();
}

function PortalMoved() {
  return (
    <main className="portal-moved">
      <Grid fullWidth>
        <Column sm={4} md={{ span: 6, offset: 1 }} lg={{ span: 8, offset: 4 }}>
          <Tile className="portal-moved__card">
            <p className="portal-moved__eyebrow">KmerHosting Domains</p>
            <h1>A new version of this portal is available in the Dashboard.</h1>
            <p>
              Search, register, transfer and manage your domains from the central KmerHosting Dashboard.
            </p>
            <Button href={dashDestination()} renderIcon={ArrowRight}>
              Open Domains in the Dashboard
            </Button>
          </Tile>
        </Column>
      </Grid>
    </main>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <DomainCarbonExperience>
      <PortalMoved />
    </DomainCarbonExperience>
  </React.StrictMode>,
);
